import React, { useEffect } from 'react'
import { useProgress } from '@react-three/drei'
import LoadingScreen from './LoadingScreen.jsx'
import { useWebCrafter } from '../hooks/useWebCrafter.jsx'
import { debugLog } from '../utils/debug.js'

export function ProgressLoader()
{
  const { progress } = useProgress()
  const {
    setLoadingProgress,
    setIsLoaded,
    managersReady,
    isLoaded
  } = useWebCrafter()

  useEffect(() =>
  {
    // Update global progress state
    setLoadingProgress(Math.floor(progress))

    // Debug logging to trace loading state
    debugLog('[ProgressLoader] Progress:', progress, 'ManagersReady:', managersReady, 'IsLoaded:', isLoaded)

    // Check if fully loaded:
    // 1. GLB and assets are loaded (progress === 100)
    // 2. Managers are initialized (managersReady === true)
    if (progress === 100 && managersReady && !isLoaded)
    {
      debugLog('[ProgressLoader] Setting isLoaded to true')
      // All setup work is done
      setIsLoaded(true)
    }

  }, [ progress, managersReady, isLoaded, setLoadingProgress, setIsLoaded ])

  return (
    <LoadingScreen progress={progress} />
  )
}

export default ProgressLoader
